import React from 'react'

import './NotFound404.scss'

import GetIcon from '../GetIcon/GetIcon';

const NotFound = props => {
  return (
    <React.Fragment>
      <div className="not-found-wrapper">
        <GetIcon name="not-found-404-colored"/>
      </div>

      <h2 className="not-found-title">404 Page Not Found</h2>
    </React.Fragment>
  )
}


export default NotFound;
